import { game } from '../main';
import { PointsCounter } from './PointsCounter';
import { SettingsMenu } from './SettingsMenu';
import { WindowLayer } from './WindowLayer';
import PowerUpButton from './PowerUpButton';
import { DifficultyDisplayBox } from 'js/DifficultyDisplayBox';
import { GameGrid } from './GameGrid';

declare const GBCXPromo;

export class GameUI extends Phaser.Group {
  private pointCounter: PointsCounter;
  private diffBox: DifficultyDisplayBox;
  private settingsMenu: SettingsMenu;
  private powerupButton: PowerUpButton;

  public static isBomb: boolean = false;

  constructor(windowLayer: WindowLayer, grid:GameGrid, spawnBomb: () => void) {
    super(game);

    this.pointCounter = new PointsCounter(700, -50);
    this.add(this.pointCounter);

    this.diffBox = new DifficultyDisplayBox(225, -50);
    this.add(this.diffBox);

    this.settingsMenu = new SettingsMenu(game.horizontal, windowLayer);
    this.add(this.settingsMenu);

    this.powerupButton = new PowerUpButton(65, -65, "bomb_power_up", ()=> {

      // add this code to disable the add and get the bomb for free when debugging
    /*  spawnBomb();
      GameUI.isBomb = true;
      return;*/

      if (this.powerupButton.availablePowerUps == 0) return;

       GBCXPromo.ads.showRewardedAd().then((bol: boolean)=> {
          if (bol){
            // the ad was watched, give the power up
            spawnBomb();

            // this is disgusting but it does the job
            GameUI.isBomb = true;

            this.powerupButton.consumePowerUp();
          }
       });
    });
    this.add(this.powerupButton);
    grid.signals.onGameOver.add((won: boolean) => {
      this.powerupButton.resetAllocation();
    });

    game.signals.onScreenResize.add(this.onResize);
    this.onResize();
  }

  private onResize = () => {
    if (game.horizontal) {
      this.y = game.world.bounds.y + game.height;
      this.pointCounter.x = 700;
      this.settingsMenu.x = 513;
      this.diffBox.x = 225;

    } else {
      this.y = game.world.bounds.y + 100;
      this.settingsMenu.x = 198;
      this.pointCounter.x = 400;
      this.diffBox.x = 200;
      // this.restartBtn.x = 580;
    }
  }

  public increaseScore(increase: number): void {
    this.pointCounter.increaseScore(increase);
  }

  public getScore(): number {
    return this.pointCounter.getScore();
  }

  public isBlockingShooter(): boolean {
    return !this.settingsMenu.open;
  }
}